import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19d62490"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "inviteModal",
  tabindex: "-1",
  "aria-labelledby": "inviteModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog--small" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title fw-bold text-center w-100" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "text-center fs-7 my-3" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "socials d-flex justify-content-center align-items-center" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16.001\" height=\"16\" viewBox=\"0 0 16.001 16\" data-v-19d62490><g id=\"link\" transform=\"translate(0.001 -0.003)\" data-v-19d62490><path id=\"Path_3493\" data-name=\"Path 3493\" d=\"M206.817,3.539a4.367,4.367,0,0,0-7.379-2.256l-2.07,2.07a1.069,1.069,0,0,0,1.512,1.512l2.07-2.071a2.231,2.231,0,1,1,3.155,3.156l-2.07,2.07a1.069,1.069,0,0,0,1.512,1.512l2.07-2.071a4.364,4.364,0,0,0,1.2-3.923Z\" transform=\"translate(-190.897)\" fill=\"#bbb\" data-v-19d62490></path><path id=\"Path_3494\" data-name=\"Path 3494\" d=\"M8.016,202.059,5.945,204.13a2.229,2.229,0,0,1-2,.613,2.22,2.22,0,0,1-1.15-.613,2.229,2.229,0,0,1-.49-.738,2.227,2.227,0,0,1,.49-2.418l2.071-2.07a1.069,1.069,0,0,0-1.512-1.511l-2.07,2.07a4.369,4.369,0,1,0,6.179,6.179l2.07-2.071a1.069,1.069,0,0,0-1.512-1.511Z\" transform=\"translate(0 -190.918)\" fill=\"#bbb\" data-v-19d62490></path><path id=\"Path_3495\" data-name=\"Path 3495\" d=\"M165.247,159.872a1.07,1.07,0,0,0-1.512,0l-3.891,3.891a1.069,1.069,0,0,0,1.512,1.511l3.891-3.891A1.067,1.067,0,0,0,165.247,159.872Z\" transform=\"translate(-154.546 -154.57)\" fill=\"#bbb\" data-v-19d62490></path></g></svg>", 1)
const _hoisted_12 = { class: "fs-7" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  id: "Group_3403",
  "data-name": "Group 3403",
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    id: "Group_3403-2",
    "data-name": "Group 3403",
    transform: "translate(0 0)"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      id: "Path_3520",
      "data-name": "Path 3520",
      d: "M1325.4,316.032a15,15,0,1,0-17.344,14.818V320.369h-3.809v-4.336h3.809v-3.3c0-3.76,2.239-5.836,5.666-5.836a23.027,23.027,0,0,1,3.358.293v3.691h-1.892a2.168,2.168,0,0,0-2.444,2.343v2.813h4.161l-.665,4.336h-3.5V330.85A15,15,0,0,0,1325.4,316.032Z",
      transform: "translate(-1295.398 -301.033)",
      fill: "#1877f2"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "Path_3521",
      "data-name": "Path 3521",
      d: "M1317.848,321.447l.666-4.345h-4.169v-2.819a2.173,2.173,0,0,1,2.449-2.348h1.9v-3.7a23.074,23.074,0,0,0-3.365-.294c-3.433,0-5.677,2.081-5.677,5.848V317.1h-3.817v4.345h3.817v10.5a15.186,15.186,0,0,0,4.7,0v-10.5Z",
      transform: "translate(-1296.998 -302.133)",
      fill: "#fff"
    })
  ])
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, [
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip-path" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        id: "Rectangle_4510",
        "data-name": "Rectangle 4510",
        width: "30",
        height: "30",
        fill: "none"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("g", {
    id: "Group_4047",
    "data-name": "Group 4047",
    transform: "translate(-0.12 -0.12)"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      id: "Group_4047-2",
      "data-name": "Group 4047",
      transform: "translate(0.12 0.12)",
      "clip-path": "url(#clip-path)"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        id: "Path_3595",
        "data-name": "Path 3595",
        d: "M30.2,15.1A15.1,15.1,0,1,1,15.1,0,15.1,15.1,0,0,1,30.2,15.1",
        transform: "translate(-0.1 -0.1)",
        fill: "#00b900"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        id: "Path_3596",
        "data-name": "Path 3596",
        d: "M40.178,32.161c0-4.494-4.505-8.151-10.044-8.151S20.09,27.666,20.09,32.161c0,4.029,3.573,7.4,8.4,8.041.327.07.772.216.885.5a2.062,2.062,0,0,1,.032.908s-.118.709-.143.86c-.044.254-.2.993.87.542a32.434,32.434,0,0,0,7.891-5.831h0a7.252,7.252,0,0,0,2.153-5.015",
        transform: "translate(-15.134 -18.067)",
        fill: "#fff"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        id: "Path_3597",
        "data-name": "Path 3597",
        d: "M49.214,47.768h-.7a.2.2,0,0,0-.2.2V52.34a.2.2,0,0,0,.2.2h.7a.2.2,0,0,0,.2-.2V47.963a.2.2,0,0,0-.2-.2",
        transform: "translate(-36.255 -35.846)",
        fill: "#00b900"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        id: "Path_3598",
        "data-name": "Path 3598",
        d: "M59.358,47.768h-.7a.2.2,0,0,0-.2.2v2.6l-2.006-2.708-.015-.02h0l-.012-.012,0,0-.011-.009-.005,0L56.4,47.8l-.006,0-.01-.006-.006,0-.011,0-.006,0-.012,0-.007,0-.011,0h-.74a.2.2,0,0,0-.2.2V52.34a.2.2,0,0,0,.2.2h.7a.2.2,0,0,0,.2-.2v-2.6l2.008,2.712a.2.2,0,0,0,.05.048l0,0,.012.007.006,0,.01,0,.009,0,.006,0,.013,0h0a.192.192,0,0,0,.05.007h.7a.2.2,0,0,0,.2-.2V47.963a.2.2,0,0,0-.2-.2",
        transform: "translate(-41.55 -35.846)",
        fill: "#00b900"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        id: "Path_3599",
        "data-name": "Path 3599",
        d: "M36.193,51.439H34.279V47.963a.2.2,0,0,0-.2-.2h-.7a.2.2,0,0,0-.2.2v4.376h0a.194.194,0,0,0,.055.135l0,0,0,0a.194.194,0,0,0,.135.054h2.815a.2.2,0,0,0,.2-.2v-.7a.2.2,0,0,0-.2-.2",
        transform: "translate(-24.932 -35.846)",
        fill: "#00b900"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        id: "Path_3600",
        "data-name": "Path 3600",
        d: "M77.668,48.864a.2.2,0,0,0,.2-.2v-.7a.2.2,0,0,0-.2-.2H74.853a.192.192,0,0,0-.135.055l0,0,0,0a.194.194,0,0,0-.054.135h0v4.375h0a.194.194,0,0,0,.055.135l0,0,0,0a.194.194,0,0,0,.135.055h2.815a.2.2,0,0,0,.2-.2v-.7a.2.2,0,0,0-.2-.2H75.754V50.7h1.914a.2.2,0,0,0,.2-.2v-.7a.2.2,0,0,0-.2-.2H75.754v-.74Z",
        transform: "translate(-55.969 -35.846)",
        fill: "#00b900"
      })
    ])
  ])
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  id: "Group_3402",
  "data-name": "Group 3402",
  xmlns: "http://www.w3.org/2000/svg",
  style: {"width":"30px","height":"30px"},
  width: "30",
  height: "30",
  viewBox: "0 0 2000 2000"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    id: "Ellipse_377",
    "data-name": "Ellipse 377",
    cx: "1000",
    cy: "1000",
    r: "1000",
    transform: "translate(0 0)",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_3519",
    "data-name": "Path 3519",
    d: "M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z",
    transform: "translate(400, 400)",
    fill: "white"
  })
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "modal-footer row mx-0 px-0 d-flex justify-content-center" }
const _hoisted_20 = { class: "d-flex col-lg-12 justify-content-center" }

import { translate } from '@/languages/i18n'
import adminRegisterService from '@/services/admin-register-alumni.service'
import Button from '@/components/button/index.vue'
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { Tooltip } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const dataShare = ref('')
const tooltipDiv = ref(null)
let tooltipInstance = null

onMounted(async () => {
  if (tooltipDiv.value) {
    tooltipInstance = new Tooltip(tooltipDiv.value, { trigger: 'manual' })
  }

  try {
    const response = await adminRegisterService.getLinkApi(route?.params?.id)
    dataShare.value = `${location.protocol + '//' + location.host}/alumni/invited_communities/alumni/` + response?.data.data.invited_code
  } catch (error) {
    console.log(error)
  }
})

const CopyText = () => {
  const copyText = document.getElementById('link')
  copyText.select()
  navigator.clipboard
    .writeText(copyText.value)
    .then(() => {
      showCopyTooltip()
    })
    .catch(() => {
      document.execCommand('copy')
    })
}

const ShareFacebook = (e: any) => {
  e.preventDefault()
  const facebookWindow = window.open(`https://www.facebook.com/sharer/sharer.php?u=${dataShare.value}`, 'facebook-popup', 'height=350,width=600')
  if (facebookWindow.focus) {
    facebookWindow.focus()
  }
  return false
}

const showCopyTooltip = () => {
  if (!tooltipInstance || !tooltipDiv.value) return
  // Update tooltip text
  tooltipDiv.value.setAttribute('data-bs-original-title', 'コピーしました')
  tooltipInstance.show()

  // Hide tooltip after 1s
  setTimeout(() => {
    tooltipInstance.hide()
  }, 1000)
}

const ShareTwitter = (e: any) => {
  e.preventDefault()
  const twitterWindow = window.open(`https://twitter.com/share?url=${dataShare.value}`, 'twitter-popup', 'height=350,width=600')
  if (twitterWindow.focus) {
    twitterWindow.focus()
  }
  return false
}
const ShareLine = (e: any) => {
  e.preventDefault()
  const lineWindow = window.open(`https://social-plugins.line.me/lineit/share?url=${dataShare.value}`, 'line-popup', 'height=550,width=600')
  if (lineWindow.focus) {
    lineWindow.focus()
  }
  return false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('alumniInvitationUrl')), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h4", _hoisted_8, _toDisplayString(_unref(translate)('getInviteLink')), 1),
          _createElementVNode("input", {
            type: "text",
            class: "form-control mb-4 text-link",
            id: "link",
            value: dataShare.value,
            readonly: ""
          }, null, 8, _hoisted_9),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              ref: (_value, _refs) => {
                _refs['tooltipDiv'] = _value
                tooltipDiv.value = _value
              },
              class: "bg-gray p-2 cursor-pointer d-flex justify-content-center align-items-center button-copy",
              onClick: CopyText
            }, [
              _hoisted_11,
              _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(translate)('copyLink')), 1)
            ], 512),
            _createElementVNode("div", {
              class: "fb ps-4 pe-2 cursor-pointer d-flex justify-content-center align-items-center text-white",
              onClick: ShareFacebook
            }, _hoisted_14),
            _createElementVNode("div", {
              class: "twt p-2 cursor-pointer d-flex justify-content-center align-items-center text-white",
              onClick: ShareLine
            }, _hoisted_16),
            _createElementVNode("div", {
              class: "line p-2 cursor-pointer d-flex justify-content-center align-items-center text-white",
              onClick: ShareTwitter
            }, _hoisted_18)
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              className: 'fw-bold'
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ]))
}
}

})